/* eslint-disable import/no-cycle */
import { call, put, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import * as types from '../../profile/actionTypes';

// import { startLoader, stopLoader } from '../../../utility/commonFunction';
import { updateProfileApi } from '../requests/profileRequest';
import { updateProfileError, updateProfileSuccess } from '../../profile/actions';
import { getMe } from '../../authentication/actions';

function* updateProfileHandler(action) {
  // yield startLoader('transparent');
  // eslint-disable-next-line no-debugger
  // debugger;
  try {
    const { data } = yield call(updateProfileApi, action?.payload);

    if (data?.status) {
      // yield stopLoader('transparent');
      yield toast.success(data?.message);
      // const modifydata = {
      //   business_name: data.data.business_name,
      //   business_category_id: data.data.business_category_id,
      //   business_category_name: data.data.business_category_name,
      //   logo: data.data.logo,
      //   colour: data.data.colour,
      //   status: data.data.status,
      //   email: data.data.user.email,
      //   role: data.data.user.role,
      //   slug: data.data.links?.[0].slug,
      // };

      // yield put(setUser(modifydata));
      yield put(getMe());
      yield put(updateProfileSuccess(true));
    } else {
      yield toast.error(data?.message);
      yield put(updateProfileError(data?.errors?.form_errors));
    }
  } catch (error) {
    yield put(updateProfileError(null));
    yield toast.error(error?.message || 'Something went wrong');
  } finally {
    // yield stopLoader('transparent');
    yield put(updateProfileError(null));
  }
}

export default function* ProfileSaga() {
  yield takeLatest(types.UPDATE_PROFILE, updateProfileHandler);
}
